import React, { useState } from "react";
import { Modal } from "antd";
import { EditorContentPermissionModalForm } from "./editor-content-permission-modal-form";

type UserDepartmentModalType = {
  onClose: () => void;
  isOpen: boolean;
  customId: string;
};

export const EditorContentPermissionModal = (props: UserDepartmentModalType) => {
  const { onClose, isOpen, customId } = props;
  const [selectedDepartment, setSelectedDepartment] = useState(null as any);

  return (
    <Modal
      open={isOpen}
      zIndex={1551}
      width={"max(90vw,700px)"}
      onCancel={() => onClose()}
      okButtonProps={{ hidden: true }}
      cancelButtonProps={{ hidden: true }}
      destroyOnClose
      centered
      title={
        <div>
          <h5 style={{ color: "#00a9c4" }}>Chọn nhân viên hoặc phòng ban</h5>
          {selectedDepartment && <div>🏢 {selectedDepartment.name}</div>}
        </div>
      }
    >
      <EditorContentPermissionModalForm
        customId={customId}
        setSelectedDepartment={setSelectedDepartment}
        onClose={onClose}
      />
    </Modal>
  );
};
